(() => {
  if (window.EpicMegaMenuRevamp) return;
  window.EpicMegaMenuRevamp = true;

  const desktop = window.matchMedia('(min-width: 990px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const hydrateCardImages = (menu) => {
    if (!menu || menu.dataset.cardImagesHydrated) return;

    menu.dataset.cardImagesHydrated = 'true';
    menu.querySelectorAll('[data-mega-menu-card-image]').forEach((media) => {
      media.style.setProperty('--mega-menu-card-image', `url("${media.dataset.megaMenuCardImage}")`);
      if (media.dataset.megaMenuCardHoverImage) {
        media.style.setProperty('--mega-menu-card-hover-image', `url("${media.dataset.megaMenuCardHoverImage}")`);
      }
    });
  };

  const setDefaultCardFilter = (menu, key = '') => {
    const defaultPanel = menu.querySelector('[data-mega-menu-default]');
    if (!defaultPanel) return;
    defaultPanel.querySelectorAll('[data-mega-menu-default-card]').forEach((card) => {
      card.hidden = Boolean(key && card.dataset.megaMenuDefaultCard !== key);
    });
  };

  const setPanel = (menu, key) => {
    const defaultPanel = menu.querySelector('[data-mega-menu-default]');
    const triggers = menu.querySelectorAll('button[data-mega-menu-trigger]');
    const panels = menu.querySelectorAll('[data-mega-menu-panel]');
    const showDefault = !key;

    const nextPanel = key ? Array.from(panels).find((panel) => panel.dataset.megaMenuPanel === key) : defaultPanel;
    if (nextPanel && !nextPanel.hidden) return;
    menu.querySelectorAll('video').forEach((video) => {
      video.pause();
      setVideoState(video.closest('.mega-menu-revamp__media'), false);
    });
    defaultPanel.hidden = !showDefault;
    triggers.forEach((trigger) => {
      const active = trigger.dataset.megaMenuTrigger === key;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-expanded', String(active));
    });
    panels.forEach((panel) => {
      panel.hidden = panel.dataset.megaMenuPanel !== key;
    });
  };

  document.addEventListener('pointerover', (event) => {
    if (!desktop.matches) return;
    const item = event.target.closest('.mega-menu-revamp__sidebar > li > a, button[data-mega-menu-trigger]');
    if (!item || item.contains(event.relatedTarget)) return;
    const menu = item.closest('[data-mega-menu-revamp]');
    if (menu.querySelector('[data-mega-menu-panel]:focus-within')) return;
    const trigger = item.matches('button') ? item : item.parentElement.querySelector('button[data-mega-menu-trigger]');
    setPanel(menu, trigger?.dataset.megaMenuTrigger || '');
    setDefaultCardFilter(menu, item.dataset.megaMenuCardFilter || '');
  });

  document.addEventListener('focusin', (event) => {
    const item = event.target.closest('.mega-menu-revamp__sidebar > li > a, button[data-mega-menu-trigger]');
    if (item) {
      const menu = item.closest('[data-mega-menu-revamp]');
      const trigger = item.matches('button') ? item : item.parentElement.querySelector('button[data-mega-menu-trigger]');
      setPanel(menu, trigger?.dataset.megaMenuTrigger || '');
      setDefaultCardFilter(menu, item.dataset.megaMenuCardFilter || '');
    }
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mega-menu-trigger]');
    if (!trigger) return;
    setPanel(trigger.closest('[data-mega-menu-revamp]'), trigger.dataset.megaMenuTrigger);
    if (event.detail === 0) document.getElementById(trigger.getAttribute('aria-controls'))?.querySelector('a, input, button')?.focus();
  });

  document.addEventListener('pointerout', (event) => {
    const menu = event.target.closest('[data-mega-menu-revamp]');
    if (!menu || menu.contains(event.relatedTarget) || menu.contains(document.activeElement) || !desktop.matches) return;
    setPanel(menu, '');
    setDefaultCardFilter(menu);
  });

  const updatePreview = (event) => {
    const link = event.target.closest('[data-mega-menu-preview-link]');
    if (!link) return;
    const panel = link.closest('[data-mega-menu-panel]');
    const card = panel?.querySelector('[data-mega-menu-preview-card]');
    if (!card) return;
    card.hidden = false;
    card.href = link.dataset.previewUrl;
    card.querySelector('[data-mega-menu-preview-image]').src = link.dataset.previewImage;
    card.querySelector('[data-mega-menu-preview-image]').alt = link.dataset.previewTitle;
    card.querySelector('[data-mega-menu-preview-title]').textContent = link.dataset.previewTitle;
  };
  document.addEventListener('pointerover', updatePreview);
  document.addEventListener('focusin', updatePreview);

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-mega-menu-submenu-filter]');
    if (!input) return;

    const query = input.value.trim().toLocaleLowerCase();
    const panel = input.closest('[data-mega-menu-panel]');
    if (!panel) return;

    let count = 0;
    panel.querySelectorAll('.mega-menu-revamp__link-group').forEach((group) => {
      let hasMatch = false;

      group.querySelectorAll('a').forEach((link) => {
        const matches = !query || link.textContent.trim().toLocaleLowerCase().includes(query);
        link.hidden = !matches;
        if (matches) count += 1;
        hasMatch = hasMatch || matches;
      });

      group.hidden = !hasMatch;
    });
    panel.querySelector('.mega-menu-revamp__link-grid').scrollTop = 0;
    const status = panel.querySelector('[data-mega-menu-filter-status]');
    status.classList.toggle('visually-hidden', count > 0 || !query);
    status.textContent = !query ? '' : count ? status.dataset.resultsText.replace('[count]', count) : status.dataset.emptyText;
  });

  const setVideoState = (container, playing) => {
    const toggle = container.closest('.mega-menu-revamp__card').querySelector('.mega-menu-revamp__video-toggle');
    const videoLabel = container.querySelector('video')?.getAttribute('aria-label') || 'video';
    container.classList.toggle('is-playing', playing);
    container.classList.toggle('is-video-visible', playing || !container.querySelector('video').paused);
    toggle?.setAttribute('aria-pressed', String(playing));
    toggle?.setAttribute('aria-label', `${playing ? 'Pause' : 'Play'} ${videoLabel}`);
  };

  document.addEventListener('pointerover', (event) => {
    const media = event.target.closest('.mega-menu-revamp__media--video');
    if (!media || media.contains(event.relatedTarget) || !desktop.matches || reducedMotion.matches) return;
    const video = media.querySelector('video');
    video.play().then(() => setVideoState(media, true)).catch(() => setVideoState(media, false));
  });

  document.addEventListener('pointerout', (event) => {
    const media = event.target.closest('.mega-menu-revamp__media--video');
    if (!media || media.contains(event.relatedTarget)) return;
    const video = media.querySelector('video');
    video.pause();
    video.currentTime = 0;
    setVideoState(media, false);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.mega-menu-revamp__video-toggle');
    if (!button || !desktop.matches) return;
    event.preventDefault();
    event.stopPropagation();
    const media = button.closest('.mega-menu-revamp__card').querySelector('.mega-menu-revamp__media--video');
    const video = media.querySelector('video');
    if (video.paused) video.play().then(() => setVideoState(media, true)).catch(() => setVideoState(media, false));
    else {
      video.pause();
      setVideoState(media, false);
    }
  });

  const initialize = (root = document) => {
    root.querySelectorAll('[data-mega-menu-revamp]').forEach((menu) => {
      const megaMenu = menu.closest('.mega-menu');
      if (!megaMenu || megaMenu.dataset.revampInitialized) return;
      megaMenu.dataset.revampInitialized = 'true';
      const toggle = megaMenu.querySelector('[data-mega-menu-toggle]');
      const content = menu.closest('.mega-menu__content');
      if (!toggle || !content) return;
      let closeTimer;
      const sizeMenu = () => {
        if (!desktop.matches) { close(); return; }
        if (!megaMenu.classList.contains('is-open')) return;
        content.style.setProperty('--mega-menu-available-height', `${Math.max(0, window.innerHeight - content.getBoundingClientRect().top - 8)}px`);
      };
      const open = () => {
        if (!desktop.matches) return;
        document.querySelectorAll('.header__inline-menu.megamenu .mega-menu.is-open').forEach((openMenu) => {
          if (openMenu !== megaMenu) openMenu.dispatchEvent(new CustomEvent('mega-menu:close'));
        });
        clearTimeout(closeTimer);
        megaMenu.classList.add('is-open');
        content.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        hydrateCardImages(menu);
        sizeMenu();
      };
      const close = () => {
        clearTimeout(closeTimer);
        megaMenu.classList.remove('is-open');
        content.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        setPanel(menu, '');
        menu.querySelectorAll('video').forEach((video) => {
          video.pause();
          setVideoState(video.closest('.mega-menu-revamp__media'), false);
        });
      };
      megaMenu.addEventListener('mega-menu:close', close);
      toggle.addEventListener('click', () => {
        if (megaMenu.classList.contains('is-open')) close();
        else open();
      });
      megaMenu.addEventListener('pointerenter', (event) => {
        if (!desktop.matches || event.pointerType !== 'mouse') return;
        clearTimeout(closeTimer);
        open();
      });
      megaMenu.addEventListener('pointerleave', () => {
        closeTimer = setTimeout(() => {
          if (!megaMenu.contains(document.activeElement)) close();
        }, 200);
      });
      megaMenu.addEventListener('focusout', () => {
        setTimeout(() => { if (!megaMenu.contains(document.activeElement)) close(); });
      });
      megaMenu.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          close();
          toggle.focus();
        }
        const trigger = event.target.closest('button[data-mega-menu-trigger]');
        if (trigger && event.key === 'ArrowRight') {
          event.preventDefault();
          setPanel(menu, trigger.dataset.megaMenuTrigger);
          document.getElementById(trigger.getAttribute('aria-controls'))?.querySelector('a, input, button')?.focus();
        }
      });
      const controller = new AbortController();
      window.addEventListener('resize', sizeMenu, { signal: controller.signal });
      desktop.addEventListener('change', () => { if (!desktop.matches) close(); }, { signal: controller.signal });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(menu)) { clearTimeout(closeTimer); close(); controller.abort(); }
      }, { signal: controller.signal });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
